import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.6.2_@types+node@20.4.1_eslint@8.44.0_typescript@5.1.6/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}